import createGetFormSyncErrors from './selectors/getFormSyncErrors';
import plain from './structure/plain';
export default createGetFormSyncErrors(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/getFormSyncErrors.js
// module id = zbJb
// module chunks = 1